import { render, staticRenderFns } from "./AdminSettingsSelect.vue?vue&type=template&id=2b5327ee&scoped=true"
import script from "./AdminSettingsSelect.vue?vue&type=script&lang=js"
export * from "./AdminSettingsSelect.vue?vue&type=script&lang=js"
import style0 from "./AdminSettingsSelect.vue?vue&type=style&index=0&id=2b5327ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5327ee",
  null
  
)

export default component.exports